'use client';

import React, { createContext, useContext, type ReactNode } from 'react';
import { useTabBar } from '../hooks/useTabBar';

type TabBarContextType = ReturnType<typeof useTabBar>;

const TabBarContext = createContext<TabBarContextType | null>(null);

export function TabBarProvider({ children }: { children: ReactNode }) {
  const tabBar = useTabBar();

  return <TabBarContext.Provider value={tabBar}>{children}</TabBarContext.Provider>;
}

export function useTabBarContext() {
  const context = useContext(TabBarContext);
  if (!context) {
    throw new Error('useTabBarContext must be used within TabBarProvider');
  }
  return context;
}

export const useTabBarState = useTabBarContext;
